import React from 'react';
import './FeaturesTitlePage.css';

export const FeaturesTitlePage = () => {
    return (
        <div className="features-title" > 
            Streamline your club operations with our powerful features below..!
        </div>
    );
};